const KEY = 'elevate_referral';
const TTL_DAYS = 60;

export const getReferral = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && Date.now() - saved.at < TTL_DAYS * 86400000) return saved.code;
  } catch (e) { /* ignore corrupted value */ }
  return null;
};

// First valid referral wins: a later ?ref= never replaces a saved, unexpired one
export const captureReferral = (apiUrl) => {
  const code = new URLSearchParams(window.location.search).get('ref');
  if (!code || getReferral()) return;
  fetch(`${apiUrl}/api/referrals/validate/${encodeURIComponent(code)}`)
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => { if (d?.valid) localStorage.setItem(KEY, JSON.stringify({ code: d.code, at: Date.now() })); })
    .catch(() => {});
};
